import { api } from '@services';
import { filterEmptyParams } from '@utils/filterEmptyParams';

export interface ManufacturerNameAndId {
  name: string;
  id: string;
}
const getManufacturersNames = async (
  search: string,
  limit?: number,
): Promise<ManufacturerNameAndId[]> => {
  const queryParams = {
    limit: String(limit || ''),
  };
  const entries = Object.entries(queryParams).filter(filterEmptyParams);
  const params = new URLSearchParams(entries);
  const { data: manufacturersNames } = await api.get<ManufacturerNameAndId[]>(
    `/manufacturers/names/${encodeURIComponent(search)}?${params.toString()}`,
  );
  getManufacturersNames;

  return manufacturersNames;
};

export { getManufacturersNames };
